import { getExperiment } from '@eventbrite/statsig';
import {
    PostCheckoutMandatoryQuestionsInAppVariant,
    POST_CHECKOUT_MANDATORY_QUESTIONS_IN_IOS_APP,
} from '../../constants/statsig';

export const getPostCheckoutMandatoryQuestionsInIosApp =
    (): PostCheckoutMandatoryQuestionsInAppVariant =>
        getExperiment(
            POST_CHECKOUT_MANDATORY_QUESTIONS_IN_IOS_APP.experiment,
            POST_CHECKOUT_MANDATORY_QUESTIONS_IN_IOS_APP.param,
            POST_CHECKOUT_MANDATORY_QUESTIONS_IN_IOS_APP.defaultValue,
        );
